
define(
    'jsx!components/ideas-lab/ideas-lab-search',[
   	"jquery",
	"underscore",
	"backbone",
    "react",
    "shared/connect-to-actions",
	"shared/connect-to-stores",
    "shared/client",
    "actions/ideas-lab",
    "shared/browser-detect",
    ], 
    function ($, _, Backbone, React, ConnectToActions, ConnectToStores, Client, IdeasLabAction, BrowserDetect){
        return React.createClass({
            displayName: "IdeasLabSearch",
            getDefaultProps: function ()
            {
                return {
                    "updatedKewords": function () {}
                };
            },
            onEnterPress: function (e) {
                if (e.nativeEvent.key === "Enter") {
                    e.target.blur()
                    if (e.target.value.trim().length === 0) {
                        this.props.updatedKewords([]);
                    } else {
                        this.props.updatedKewords(e.target.value);
                    }
                    e.currentTarget.value = "";

                    if(BrowserDetect.isMobileStrict()) {
                        document.getElementById("sidebar").style.left = "-270px";
                        document.getElementById("mobile-search-button").className = "icons8-search";
                    }
                }

            },
            render: function ()
            {
                return (
                    React.createElement("div", {className: "ideas-lab-search"}, 
                        React.createElement("input", {type: "text", id: "ideas-lab-input", "aria-label": "Search", placeholder: "Type & Hit enter to search", onKeyDown: this.onEnterPress})
                    )
                );
            }
        });
    }
);
